import React, { useEffect, useState, useRef } from "react";
import { Button, ModalBody, Card, Modal, ModalHeader, } from 'reactstrap'

// import stylesheet if you're not already using CSS @import
import "react-image-gallery/styles/css/image-gallery.css";
import { start } from "service";
import { URL } from "Auth/config";

import "./style.css"

import toast from "react-hot-toast";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShare } from "@fortawesome/free-solid-svg-icons";
// import "./app.js"


export default function Fotografias() {

  const [imagen, setImagen] = useState(null);



  const [images, setImages] = useState([]);
  const [page, setPage] = useState(1);
  const loaderRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [anterior, setAnterior] = useState(100000000);

  // Simula la carga de imágenes desde una API
  const fetchImages = (page) => {
    start(URL + '/public/listar-imagenes', { anterior }).then(j => {
      let newImages = []
      let c = 1
      for (let i of j) {
        newImages.push({
          id: i.id,
          url: URL + 'imagenes/' + i.id + '.png',
          views: i.views,
          fecha: i.fecha,
          titulo: i.titulo,
          descripcion: i.descripcion,
          categoria: i.categoria,
          autor: i.autor,
        });
        if (c == 10) {
          setAnterior(i.id)
        }
        c++
      }
      setImages((prevImages) => [...prevImages, ...newImages]);
    })

  };



  useEffect(() => {
    fetchImages(page);
  }, [page]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setPage((prevPage) => prevPage + 1);
        }
      },
      { threshold: 1.0 }
    );

    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }

    return () => {
      if (loaderRef.current) {
        observer.unobserve(loaderRef.current);
      }
    };
  }, []);




  return (

    <>
      <div className="contentSimple"  >
        <div className="main-container">
          <header>
            <h1>IECC <br /> <span>[ contenido de sensibilizacion en imagenes ]</span></h1>
          </header>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))", gap: "10px" }}>
            {images.map((image, index) => (
              <div className="gallery-item mb-2" key={index}>
                <div className="image-container">
                  <img key={image.id} src={image.url} alt={`Imagen IECC ${image.descripcion}`} style={{ width: "100%" }}
                    onClick={async () => {

                      const data = await start(URL + '/public/obtener-imagen', { image: image.id })
                      if (data.length > 0) {


                        for (let j of data) {
                          setImagen({
                            id: j.id,
                            url: image.url,
                            titulo: j.titulo,
                            descripcion: j.descripcion,
                            view: j.views,
                            autor: j.autor
                          });
                          setOpen(true)
                        }

                        axios.post(URL + '/public/contar-visita', { id: image.id })
                        // for (let item of images) {
                        //   if (item.id === image.id) {
                        //     item.views++
                        //   }
                        // }
                      } else toast.error('IMAGEN NO ENCONTRADO')

                    }} >
                  </img>
                  <div className="video-info">
                    <h3 style={{ fontSize: '0.9rem', marginBottom: '0' }}>{image.titulo}</h3>
                    <p style={{ fontSize: '0.8rem', marginBottom: '0' }}>{image.autor}</p>
                    <div className="video-metadata">
                      <span className="fecha" style={{ fontSize: '0.75rem', marginBottom: '0' }}>
                        <i className="tim-icons icon-calendar-60 mr-1"></i>
                        {new Date(image.fecha).toLocaleDateString('es-ES')}
                      </span>
                      <span className="visualizaciones" style={{ fontSize: '0.75rem', marginBottom: '0' }}>
                        <i className="tim-icons icon-eye-2 mr-1"></i>
                        {image.views}
                      </span>
                    </div>
                  </div>
                  {/* <FontAwesomeIcon icon={faShare}
                    style={{
                      position: 'relative',
                      bottom: '130px',
                      right: '-390px',
                      // background: 'rgba(52, 152, 219,0.9)',
                      padding: '10px',
                      color: "white",
                      boxShadow: '0 4px 15px rgba(237, 248, 255)',
                      borderRadius: '8px'

                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 6px 20px rgba(52, 152, 219, 0.4)';
                      e.currentTarget.style.transition= 'all 0.3s ease'

                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(52, 152, 219, 0.3)';
                      e.currentTarget.style.transition= 'all 0.3s ease'
                    }}
                  /> */}
                </div>
              </div>
            ))}
            <div ref={loaderRef} style={{ height: "50px", backgroundColor: "lightgray", marginTop: "10px" }}>
              Cargando más imágenes...
            </div>
          </div>
        </div>
      </div>

      <Modal isOpen={open} toggle={() => setOpen(!open)} className="modal-lg">
        <style>
          {`
              .modal-header{
                background:#212529;
              
                padding: 10px;
                border-radius:0;
              }
              .modal-content .modal-header .modal-title {
                color: white !important;
                margin-bottom: 0px;
              }
              .modal-header .close {
                color: white !important;
                display:none;
              }
                .white-content .modal-content {
                  background: transparent !important;
                }

                @media (min-width: 576px) {
                  .modal-dialog {
                    margin: 5px auto;
                  }
}
             
          `}
        </style>
        {/* <ModalHeader toggle={() => setOpen(!open)}>
          {imagen?.titulo}
        </ModalHeader> */}
        <ModalBody style={{ background: '#212529', padding: '0', display: 'flex', justifyContent: 'center' }}>
          <img src={imagen?.url} alt={`Image ${imagen?.id}`} style={{ width: "auto", height: window.innerWidth < 600 ? 'auto' : window.innerHeight + 50 }}
            onClick={() => {
              var ruta = imagen?.url;

              var enlace = document.createElement('a');

              enlace.href = ruta;

              enlace.download = ruta;

              document.body.appendChild(enlace);

              enlace.click();
              enlace.parentNode.removeChild(enlace);
            }}
          />

        </ModalBody>
        <div style={{
          margin: '10px',
          padding: '10px',
          background: '#344675',
          position: "relative",
          bottom: window.innerWidth < 600 ? '100px' : '150px',
          zIndex: '1000',
          width: "300px",
          // height: 'auto'
        }}>
          {imagen ? <>
            <p style={{
              color: 'white',
              marginBottom: '0',
              fontWeight: '600'
            }}>{imagen?.titulo}</p>
            <p style={{
              color: 'white',
              fontSize: '10px',
              marginBottom: '0',
            }}>{imagen?.descripcion}</p>
            <p style={{
              color: 'white',
              fontSize: '9px',
              marginBottom: '0',
              fontWeight: '600',
            }}>{imagen?.autor}</p>
            <p style={{
              color: 'white',
              fontSize: '9px',
              marginBottom: '0',
            }}>{imagen?.view}</p>
          </> : null}
        </div>
        <div
          style={{
            padding: '0',
            display: 'flex',
            justifyContent: 'center',
            position: 'relative',
            bottom: window.innerWidth < 600 ? '100px' : '150px',
            background: "transparent !important",
          }}
        >
          <Button color="info" onClick={() =>
            setOpen(false)
          }>
            cerrar
          </Button>

        </div>

      </Modal>


    </>

  )
}